import { useMediaQuery } from "usehooks-ts";

// px değerini key'den çıkart (base = 0)
const parseBreakpoint = (key: string) => {
  if (key === "base") return 0;
  return Number(key.replace("w", ""));
};

export function useTemplates() {
  // 1. Tüm template'leri { width, template } formatına çevir
  const entries = Object.entries(TEMPLATES).map(([key, template]) => ({
    key,
    width: parseBreakpoint(key),
    template,
  }));

  // 2. breakpoints küçükten büyüğe sırala
  const sorted = entries.sort((a, b) => a.width - b.width);

  // 3. Her breakpoint için media query oluştur
  const matches = sorted.map((entry) =>
    useMediaQuery(`(min-width: ${entry.width}px)`)
  );

  // 4. En büyük TRUE breakpoint’i seç
  let active = sorted[0]; // base
  for (let i = 0; i < sorted.length; i++) {
    if (matches[i]) active = sorted[i];
  }

  return active.template;
}

export const TEMPLATES = {
  base: [
    "minmax(210px,1fr)",
    "116px",
    "80px",
    "95px",
    "95px",
    "183px",
    "120px",
    "72px",
  ],

  w1290: [
    "minmax(200px,1fr)",
    "126px",
    "101px",
    "95px",
    "95px",
    "183px",
    "120px",
    "72px",
  ],

  w1360: [
    "minmax(230px,1fr)",
    "126px",
    "101px",
    "117px",
    "101px",
    "183px",
    "129px",
    "82px",
  ],

  w1420: [
    "minmax(230px,1fr)",
    "136px",
    "111px",
    "127px",
    "111px",
    "193px",
    "139px",
    "82px",
  ],

  w1490: [
    "minmax(270px,1fr)",
    "146px",
    "121px",
    "137px",
    "121px",
    "203px",
    "149px",
    "82px",
  ],

  w1620: [
    "minmax(270px,1fr)",
    "156px",
    "111px",
    "157px",
    "151px",
    "213px",
    "180px",
    "82px",
  ],

  w1740: [
    "minmax(270px,1fr)",
    "176px",
    "131px",
    "167px",
    "161px",
    "223px",
    "190px",
    "82px",
  ],

  w1860: [
    "minmax(270px,1fr)",
    "230px",
    "131px",
    "190px",
    "190px",
    "223px",
    "190px",
    "82px",
  ],
};
